import React from "react";
import useForm from '../../../hooks/useForm';
import useDataEvents from "../../../dataHooks/useDataEvents";
import { FormField,  Modal, Button } from '@prosolve/common-components-ui'

export default ({
  eventData = {},
  onClose,
  onSuccess,
}) => {
  const {
    isLoading,
    updateEventDeliveryNotes
  } = useDataEvents();

  const formSchema = {
    requiredFields: ['deliveryNotes'],
    initData: {
      deliveryNotes: eventData.deliveryNotes
    }
  };

  const formData = useForm(formSchema)

  const onClickSubmit = async (isDelivered) => {
    if (!isLoading && formData.isValid()) {
      const data = { 
        ...formData.values, 
        id: eventData.id, 
        isDelivered 
      }
      const jsonData = await updateEventDeliveryNotes(data)
      if (jsonData.success) {
        onSuccess()
      }
      onClose()
    }
  }

  const footer = (
    <div>
      <div style={{ 
        display: 'flex',
        columnGap: '10px',
        padding: '10px'
      }}>
        <div style={{ flexGrow: 1 }}></div>
        <Button onClick={onClose}>
          {'Cancel'}
        </Button>
        <Button onClick={() => onClickSubmit(true)} $colored={true} $disabled={isLoading}>
          {'Submit'}
        </Button>
      </div>
    </div>
  )

  return (
    <Modal title={'Close Event'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <FormField
          style={{ flex: 1 }}
          fieldId='deliveryNotes'
          type='textarea'
          label={'Enter notes on what was delivered.'}
          placeholder=''
          formData={formData}
        />
      </div>
    </Modal>
  )
}